import {PREVENT_SCROLL_CLASSNAME} from '../constant/talkViewerConstant';

export function disableScroll() {
  if (typeof window === 'undefined') {
    return;
  }
  !document.body.classList.contains(PREVENT_SCROLL_CLASSNAME) &&
    document.body.classList.add(PREVENT_SCROLL_CLASSNAME);
}
